/**
 * useFrenchHolidays(year)
 * Retourne un Set de chaînes 'yyyy-MM-dd' correspondant aux jours fériés français.
 * Algorithme de Butcher pour Pâques + tous les fériés fixes.
 * Zéro dépendance externe.
 */

/**
 * Hook React — mémoïsé par année.
 * Usage : const holidays = useFrenchHolidays(2025);
 *         holidays.has('2025-05-01') → true
 */
import { useMemo } from 'react';

function easterDate(year) {
    // Algorithme de Butcher (méthode anonyme grégorienne)
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31); // 3=mars, 4=avril
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
}

function addDaysToDate(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
}

function toISO(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function getFrenchHolidays(year) {
    const easter = easterDate(year);

    const holidays = [
        // Fixes
        new Date(year, 0, 1),   // Jour de l'an
        new Date(year, 4, 1),   // Fête du Travail
        new Date(year, 4, 8),   // Victoire 1945
        new Date(year, 6, 14),  // Fête Nationale
        new Date(year, 7, 15),  // Assomption
        new Date(year, 10, 1),  // Toussaint
        new Date(year, 10, 11), // Armistice
        new Date(year, 11, 25), // Noël

        // Mobiles (relatifs à Pâques)
        addDaysToDate(easter, 1),   // Lundi de Pâques
        addDaysToDate(easter, 39),  // Ascension
        addDaysToDate(easter, 49),  // Dimanche de Pentecôte
        addDaysToDate(easter, 50),  // Lundi de Pentecôte
    ];

    return new Set(holidays.map(toISO));
}

export default function useFrenchHolidays(year) {
    return useMemo(() => getFrenchHolidays(year), [year]);
}